// (function($) {
//   "use strict";

//   jQuery(document).ready(function(){

//     // preloader
//     /*
//     $(window).on('load', function() {
//       $('#preloader_active').fadeOut('slow');
//     });
//     */



//     /*--------------------------
//     1. Newsletter Popup
//     ---------------------------*/
//     setTimeout(function () {
//       $('.popup_wrapper').css({
//         "opacity": "1",
//         "visibility": "visible"
//       });
//       $('.popup_off').on('click', function () {
//         $(".popup_wrapper").fadeOut(500);
//       })
//     }, 2500);

//     /*----------------------------
//     2. Mobile Menu Activation
//     -----------------------------*/
//     jQuery('.mobile-menu nav').meanmenu({
//       meanScreenWidth: "991",
//     });

//     /*----------------------------
//     3 Checkout Page Activation
//     -----------------------------*/
//     $('.categorie-title').on('click', function () {
//       $('.vertical-menu-list').slideToggle();
//     });

//     $('#showlogin').on('click', function () {
//       $('#checkout-login').slideToggle();
//     });
//     $('#showcoupon').on('click', function () {
//       $('#checkout_coupon').slideToggle();
//     });
//     $('#cbox').on('click', function () {
//       $('#cbox_info').slideToggle();
//     });
//     $('#ship-box').on('click', function () {
//       $('#ship-box-info').slideToggle();
//     });


//     /*----------------------------
//     13. WOW Js Activation
//     -----------------------------*/
//     //     new WOW().init();

//     /*----------------------------
//     14. ScrollUp Activation
//     -----------------------------*/
//     $.scrollUp({
//       scrollName: 'scrollUp', // Element ID
//       topDistance: '550', // Distance from top before showing element (px)
//       topSpeed: 1000, // Speed back to top (ms)
//       animation: 'fade', // Fade, slide, none
//       scrollSpeed: 900,
//       animationInSpeed: 1000, // Animation in speed (ms)
//       animationOutSpeed: 1000, // Animation out speed (ms)
//       scrollText: '<i class="fa fa-angle-up"></i>', // Text for element
//       activeOverlay: false // Set CSS color to display scrollUp active point, e.g '#00FFFF'
//     });

//     /*----------------------------
//     15. Sticky-Menu Activation
//     ------------------------------ */
//     $(window).scroll(function () {
//       if ($(this).scrollTop() > 150) {
//         $('.header-sticky').addClass("sticky");
//       } else {
//         $('.header-sticky').removeClass("sticky");
//       }
//     });

//     /*----------------------------
//     16. Price Slider Activation
//     -----------------------------*/
//     $("#slider-range").slider({
//       range: true,
//       min: 0,
//       max: 80,
//       values: [0, 74],
//       slide: function (event, ui) {
//         $("#amount").val("$" + ui.values[0] + "  $" + ui.values[1]);
//       }
//     });
//     $("#amount").val("$" + $("#slider-range").slider("values", 0) +
//                      "  $" + $("#slider-range").slider("values", 1));


//     /*----------------------------------------------------
//     19. Best Product Activation
//     -----------------------------------------------------*/
//     $('.best-seller-pro-two')
//     .owlCarousel({
//       loop: false,
//       nav: false,
//       dots: false,
//       smartSpeed: 1200,
//       margin: 0,
//       responsive: {
//         0: {
//           items: 1,
//           autoplay:true
//         },
//         768: {
//           items: 3
//         },
//         1000: {
//           items: 1
//         }
//       }
//     })

//     /*-------------------------------------
//     20. Blog Realted Post activation
//     --------------------------------------*/
//     $('.blog-related-post-active').owlCarousel({
//       loop: false,
//       margin: 30,
//       smartSpeed: 1000,
//       nav: false,
//       dots: false,
//       items: 2,
//       responsive: {
//         0: {
//           items: 1,
//           autoplay:true
//         },
//         480: {
//           items: 1
//         },
//         768: {
//           items: 2
//         },
//         992:{
//           margin: 29,
//           items: 2
//         },
//         1200: {
//           items: 2
//         }
//       }
//     })

//     /*----------------------------------------------------
//     21.Best Seller  Unique Activation
//     -----------------------------------------------------*/
//     $('.best-seller-unique').on('changed.owl.carousel initialized.owl.carousel', function (event) {
//       $(event.target)
//       .find('.owl-item').removeClass('last')
//       .eq(event.item.index + event.page.size - 1).addClass('last');
//     }).owlCarousel({
//       loop: false,
//       nav: true,
//       dots: false,
//       smartSpeed: 1000,
//       navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
//       margin: 0,
//       responsive: {
//         0: {
//           items: 1,
//           autoplay:true
//         },
//         768: {
//           items: 2
//         },
//         1000: {
//           items: 1
//         }
//       }
//     })

//     // Ajax Wishlist
//     $(".cart-item").on('click', function(){
//       $(this).addClass("loading add-item");
//       setTimeout(function () {
//         $(".cart-item").removeClass("loading");
//       },1000);
//       setTimeout(function () {
//         $(".cart-item").removeClass("add-item");
//       },1800);

//     });

//     // Remove Hyperlink
//     $(".remove_href").removeAttr("href");


//     $(".prod_price span:first-child").addClass("price");
//     $(".prod_price span:last-child").addClass("prev-price");


//   });

// })(jQuery);

$(".menu-open-btn").on("click", function() {
  $(".mobile-menu-drawer").toggleClass('open-mobile-menu');
});
$(".close-mobile-menu-icon").on("click", function() {
  $(".mobile-menu-drawer").removeClass('open-mobile-menu');
});

$(document).ready(function(){
  $('.slideshowo-img-wrap').slick({
    slidesToShow: 1,
//     adaptiveHeight: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 1500,
    prevArrow: '<button class="slick-prev-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/></svg></button>',
    nextArrow: '<button class="slick-next-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"/></svg></button>',
  });
  
  $('.slideshowo-img-wrap').slick('refresh');

  $('.brands-inner').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed:1500,
    prevArrow: '<button class="slick-prev-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/></svg></button>',
    nextArrow: '<button class="slick-next-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"/></svg></button>',  
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.new-upsell-pro').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/></svg></button>',
    nextArrow: '<button class="slick-next-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.product_image .tab-pane').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumb-menu'
  });
  $('.thumb-menu').slick({
    slidesToShow: 3,
    draggable: false,
    slidesToScroll: 1,
    asNavFor: '.product_image .tab-pane',
    focusOnSelect: true,
    prevArrow: '<button class="slick-prev-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/></svg></button>',
    nextArrow: '<button class="slick-next-btn slick-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"/></svg></button>',

  });

  //   STICKY
  //   var stickyNavTop = $('.header-sticky').offset().top;

  //   var stickyNav = function(){
  //     var scrollTop = $(window).scrollTop();

  //     if (scrollTop > stickyNavTop) { 
  //       $('.header-sticky').addClass('sticky');
  //     } else {
  //       $('.header-sticky').removeClass('sticky'); 
  //     }
  //   };

  //   stickyNav();

  //   $(window).scroll(function() {
  //     stickyNav();
  //   });

});

// $(window).scroll(function(){
//   var sticky = $('.header-sticky'),
//       scroll = $(window).scrollTop();

//   if (scroll >= 100) sticky.addClass('sticky');
//   else sticky.removeClass('sticky');
// });

$(window).scroll(function() 
                 {
  if ($(this).scrollTop() > 100)
  {
    $('.header-sticky').addClass("sticky");
  }
  else
  {
    $('.header-sticky').removeClass("sticky");
  }
});


$('.change-view').on('click', function() {
  $('.change-view').removeClass("change-view--active");
  $(this).addClass("change-view--active");

  //   $.ajax({
  //    url: "https://www.flexra.net/collections/all",
  //     type: 'GET',
  //     success: function(res) {
  //         console.log(res);
  //         alert(res);
  //     }
  //   });
  var location1 = location.href;
  var data = $(this).attr('data-view');

  var url = location1 + '?view=' + data;

  if(location1.indexOf('?') > -1){
    if(location1.indexOf('list') > -1){
      var url = location1.replace('list','grid');
    }else if(location1.indexOf('grid') > -1){
      var url = location1.replace('grid','list');
    }

  }
  //           hasParams = url.indexOf('?') > -1;

  window.location = url;


});
$(document).ready(function(){
  var urls = location.href;
  if(urls.indexOf('grid') > -1){
    $('#grid-view').show();
    $('#list-view').hide();
  }
  else if(urls.indexOf( 'list') > -1){
    $('#grid-view').hide();
    $('#list-view').show();
  }
  else{
    $('#grid-view').show();
    $('#list-view').hide();
  }
});

// footer toggel

if($(window).width() < 768) { 
//   console.log("fopter");
  //BEGIN
  $(".footer-content").hide();
  $(".footer-title").on("click", function(e) {

    e.preventDefault();

    var $this = $(this);

    if (!$this.hasClass("footer__active")) {
      $(".footer-content").hide();
      $(".footer-title").removeClass("footer__active");

    }

    $this.toggleClass("footer__active");
    $this.next().toggle();

  });
  //END

}


//product page quantity

$(document).on('click', '.js-qty__adjust--minus', function (event) {
  var qty_val = parseInt($('.js-qty__num').val());
  if( qty_val > 1) {
    var quantity = qty_val - 1 ;
    $('.js-qty__num').val(quantity);
  }
});

$(document).on('click', '.js-qty__adjust--plus', function (event) {
  var qty_val = parseInt($('.js-qty__num').val());
  var quantity = qty_val+1 ;
  $('.js-qty__num').val(quantity);
});

